import {
  IComponentVolumes,
  ICountry,
  ILang,
  ILocation,
  IModal,
  IRecommendations,
  ISearchProduct,
  ISearchVehicle,
  IServiceIntervals,
  ITWorkshop,
  IVehicle,
  LocationCategory,
  LocationType,
  ProductCategory,
  Replacement,
} from '../interface';

const actionTypes = {
  SET_VEHICLE: 'SET_VEHICLE',
  SET_PRODUCTCATEGORIES: 'SET_PRODUCTCATEGORIES',
  SET_LOCATIONCATEGORIES: 'SET_LOCATIONCATEGORIES',
  SET_OILS: 'SET_OILS',
  SET_ADDRESS: 'SET_ADDRESS',
  SET_WORKSHOP_TYPE: 'SET_WORKSHOP_TYPE',
  SET_WORKSHOP_LOW_RATING: 'SET_WORKSHOP_LOW_RATING',
  SET_WORKSHOP_UP_RATING: 'SET_WORKSHOP_UP_RATING',
  SET_OPEN_HOURS: 'SET_OPEN_HOURS',
  SET_CLOSE_HOURS: 'SET_CLOSE_HOURS',
  SET_PROMOTIONS: 'SET_PROMOTIONS',
  SET_LOCATION_TYPE: 'SET_LOCATION_TYPE',
  SET_SORT: 'SET_SORT',
  SET_WORKSHOPS: 'SET_WORKSHOPS',
  SET_MODAL: 'SET_MODAL',
  SET_LANG: 'SET_LANG',
  SET_COUNTRY: 'SET_COUNTRY',
  SET_DISTANCE: 'SET_DISTANCE',
  SET_COUNTRIES: 'SET_COUNTRIES',
  SET_REPLACEMENTS: 'SET_REPLACEMENTS',
  SET_SERVICEINTERVALS: 'SET_SERVICEINTERVALS',
  SET_COMPONENTVOLUMES: 'SET_COMPONENTVOLUMES',
  SET_LANGS: 'SET_LANGS',
  SET_SELECTEDLOCATION: 'SET_SELECTEDLOCATION',
  SET_WHERETOBUYENABLED: 'SET_WHERETOBUYENABLED',
  SET_LOCATIONTYPESLIST: 'SET_LOCATIONTYPESLIST',
  SET_LOCATIONCATEGORIESLIST: 'SET_LOCATIONCATEGORIESLIST',
  SET_PRODUCTCATEGORIESLIST: 'SET_PRODUCTCATEGORIESLIST',
  SET_WHERETOSERVICESENDABLED: 'SET_WHERETOSERVICESENABLED',
  SET_HASCASTROLCERTIFIEDWORKSHOPS: 'SET_HASCASTROLCERTIFIEDWORKSHOPS',
  SET_ENABLEWTBDISTANCEFILTER: 'SET_ENABLEWTBDISTANCEFILTER',
  SET_ISMILES: 'SET_ISMILES',
  SET_DISTANCEINMILESORKM: 'SET_DISTANCEINMILESORKM',
  SET_RECOMMENDEDPRODUCTS: 'SET_RECOMMENDEDPRODUCTS',
  SET_RESULTS: 'SET_RESULTS',
  SET_LICENSEKEYS: 'SET_LICENSEKEYS',
  SET_LOADING: 'SET_LOADING',
};

const actions = {
  setVehicle: (vehicle: IVehicle | undefined) => {
    return { type: 'SET_VEHICLE', vehicle };
  },
  setProductCategories: (productCategories: string[]) => {
    return { type: 'SET_PRODUCTCATEGORIES', productCategories };
  },
  setLocationCategories: (locationCategories: string[]) => {
    return { type: 'SET_LOCATIONCATEGORIES', locationCategories };
  },
  setOils: (oils: string[]) => {
    return { type: 'SET_OILS', oils };
  },
  setAddress: (address: ILocation | undefined) => {
    return { type: 'SET_ADDRESS', address };
  },
  setWorkshopLowRating: (workshopLowRating: number) => {
    return { type: 'SET_WORKSHOP_LOW_RATING', workshopLowRating };
  },
  setWorkshopUpRating: (workshopUpRating: number) => {
    return { type: 'SET_WORKSHOP_UP_RATING', workshopUpRating };
  },
  setOpenHours: (openHours: number) => {
    return { type: 'SET_OPEN_HOURS', openHours };
  },
  setCloseHours: (closeHours: number) => {
    return { type: 'SET_CLOSE_HOURS', closeHours };
  },
  setLocationType: (locationType: string[]) => {
    return { type: 'SET_LOCATION_TYPE', locationType };
  },
  setSort: (sort: string) => {
    return { type: 'SET_SORT', sort };
  },
  setWorkshops: (workshops: ITWorkshop[]) => {
    return { type: 'SET_WORKSHOPS', workshops };
  },
  setModal: (modal: IModal) => {
    return { type: 'SET_MODAL', modal };
  },
  setLang: (lang: string) => {
    return { type: 'SET_LANG', lang };
  },
  setDistance: (distance: string) => {
    return { type: 'SET_DISTANCE', distance };
  },
  setCountry: (country: ICountry) => {
    return { type: 'SET_COUNTRY', country };
  },
  setCountries: (countries: ICountry[]) => {
    return { type: 'SET_COUNTRIES', countries };
  },
  setReplacements: (replacements: Replacement) => {
    return { type: 'SET_REPLACEMENTS', replacements };
  },
  setServiceIntervals: (serviceIntervals: IServiceIntervals[]) => {
    return { type: 'SET_SERVICEINTERVALS', serviceIntervals };
  },
  setVehicleComponentVolumes: (
    vehicleComponentVolumes: IComponentVolumes[],
  ) => {
    return { type: 'SET_COMPONENTVOLUMES', vehicleComponentVolumes };
  },
  setLangs: (langs: ILang[]) => {
    return { type: 'SET_LANGS', langs };
  },
  setSelectedLocation: (selectedLocation: ITWorkshop | null) => {
    return { type: 'SET_SELECTEDLOCATION', selectedLocation };
  },
  setWhereToBuyEnabled: (whereToBuyEnabled: boolean) => {
    return { type: 'SET_WHERETOBUYENABLED', whereToBuyEnabled };
  },
  setLocationTypesList: (locationTypesList: LocationType[]) => {
    return { type: 'SET_LOCATIONTYPESLIST', locationTypesList };
  },
  setLocationCatetoriesList: (locationCategoriesList: LocationCategory[]) => {
    return { type: 'SET_LOCATIONCATEGORIESLIST', locationCategoriesList };
  },
  setProductCatetoriesList: (productCategoriesList: ProductCategory[]) => {
    return { type: 'SET_PRODUCTCATEGORIESLIST', productCategoriesList };
  },
  setWhereToServiceEnabled: (whereToServiceEnabled: boolean) => {
    return { type: 'SET_WHERETOSERVICESENABLED', whereToServiceEnabled };
  },
  setEnableWtbDistanceFilter: (enableWtbDistanceFilter: boolean) => {
    return { type: 'SET_ENABLEWTBDISTANCEFILTER', enableWtbDistanceFilter };
  },
  setIsMiles: (isMiles: boolean) => {
    return { type: 'SET_ISMILES', isMiles };
  },
  setDistanceInMilesOrKM: (distanceInMilesOrKM: number) => {
    return { type: 'SET_DISTANCEINMILESORKM', distanceInMilesOrKM };
  },
  setHasCastrolCertifiedWorkshops: (hasCastrolCertifiedWorkshops: boolean) => {
    return { type: 'SET_HASCASTROLCERTIFIEDWORKSHOPS', hasCastrolCertifiedWorkshops };
  },
  setRecommendedProducts: (recommendedProducts: IRecommendations[]) => {
    return {type: 'SET_RECOMMENDEDPRODUCTS', recommendedProducts: recommendedProducts};
  },
  setResults: (results: ISearchVehicle[] | ISearchProduct[] | null) => {
    return {type: 'SET_RESULTS', results: results};
  },
  setLicenseKeys: (licenseKeys: string) => {
    return {type: 'SET_LICENSEKEYS', licenseKeys: licenseKeys};
  },
  setLoading: (loading: boolean) => {
    return {type: 'SET_LOADING', loading: loading}
  }
};

export { actionTypes };
export default actions;
